import React from 'react';
import { Icon, Tooltip } from 'antd';
import moment from 'moment';
import isNaN from 'lodash/isNaN';
import { LEVEL } from './constants';
import converPricingValue from 'util/convertPricingValue';

const renderDataComp = (value, sample, name, isNotExact) => {
  if (sample) {
    return <div>
      <div>{value ? <><div>{name}</div><div>{converPricingValue(Math.round(value))}</div></> : '--'}</div>
      <div className='gx-text-primary'>* Sample: {sample ? converPricingValue(Math.round(sample)) : '--'}</div>
      {isNotExact ? <div className='gx-text-danger'><Tooltip title='Brand created manually'>* M</Tooltip></div> : ''}
    </div>
  }
  return <>{value ? <><div>{name}</div><div>{converPricingValue(Math.round(value))}</div></> : '--'}{isNotExact ? <div className='gx-text-danger'>* M</div> : ''}</>
};

const Columns = (brands, groups, length, isAdmin, pages) => {
  const brandColumnss = brands.map(brand => (
      {
        title: `Brand ${brand.key}`,
        align: 'center',
        key: `brand_${brand.key}`,
        dataIndex: 'brands',
        render: (values, record, index) => {
          const value = values.find(value => value.key === brand.key).value;
          let content = '--';
          if (typeof(value) === 'object') {
            content = renderDataComp(value.comp, value.sample, value.name, value.isNotExact);
          } else {
            content = value === 0 ? '--' : <span className='gx-text-secondary'>{!isNaN(value) && value === 1 ? <Icon twoToneColor='#fa8c15' type="check-square" theme="twoTone" /> : LEVEL[value] ? LEVEL[value].value : converPricingValue(Math.round(value))}</span>;
          }
          const obj = {
            children: content,
            props: {},
          };
          if (index % 14 === 0) {
            obj.props.colSpan = 0;
          }
          return obj;
        },
      }
    )
  );

  return [
    {
      title: 'Sow',
      dataIndex: 'sow',
      width: 100,
      render: (value, row, index) => {
        const obj = {
          children: value,
          props: {},
        };
        if (index % 14 === 0) {
          obj.children = <div>
            <div>
              TIME: {moment(row.created_at * 1000).format('YYYY-MM-DD HH:mm:ss')}
            </div>
            <div>
              Người tạo: {row.created_by}
            </div>
            <div>
              CRM ID: {row.project}
            </div>
            <div>
              CATEGORY: {row.level}
            </div>
            <div>
              DATA FREQ: {row.data_freq}
            </div>
            <div>
              TOTAL PRICE: {row.price ? converPricingValue(Math.round(row.price)) : 0} đ
            </div>
          </div>
          obj.props.colSpan = 13;
          obj.props.className = 'total-row'
        }
        if (pages.includes(index)) {
          obj.children = '';
        }
        return obj;
      }
    },
    {
      title: 'Price (vnđ)',
      align: 'right',
      dataIndex: 'unit_price',
      render: (value, row, index) => {
        const obj = {
          children: [6].includes(index) ? 0 : value ? converPricingValue(Math.round(value)) : 0,
          props: {},
        };
        if (index % 14 === 0) {
          obj.props.colSpan = 0;
        }
        if (pages.includes(index)) {
          obj.children = '';
        }
        return obj;
      }
    },
    {
      title: 'Freq',
      dataIndex: 'freq',
      render: (value, row, index) => {
        const obj = {
          children: value,
          props: {},
        };
        if (index % 14 === 0) {
          obj.props.colSpan = 0;
        }
        if (pages.includes(index)) {
          obj.children = '';
        }
        return obj;
      }
    },
    ...brandColumnss,
  ];
};

export default Columns;
